// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3x0YA","label":"Category_label__1fJ6b","content":"Category_content__3WfDK","header":"Category_header__1_z1g","location":"Category_location__2r0dK"};